"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStreemshotResponses = exports.useRoomSessionDetections = exports.useRoomSession = exports.createRoomSessionProvider = void 0;
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const factory_1 = require("./factory");
const rxjs_1 = require("../hooks/rxjs");
_a = (0, factory_1.createContextFactory)('RoomSession'), exports.createRoomSessionProvider = _a[0], exports.useRoomSession = _a[1];
const useRoomSessionDetections = () => {
    const roomSession = (0, exports.useRoomSession)();
    const [detections] = (0, rxjs_1.useObservable)(roomSession.detections.getDetections({
        types: [
            streem_sdk_protobuf_1.streem.api.Detection.Type.DETECTION_TYPE_MODEL,
            streem_sdk_protobuf_1.streem.api.Detection.Type.DETECTION_TYPE_SERIAL,
        ],
    }));
    return detections || [];
};
exports.useRoomSessionDetections = useRoomSessionDetections;
const useStreemshotResponses = () => {
    const roomSession = (0, exports.useRoomSession)();
    const [streemshots] = (0, rxjs_1.useObservable)(roomSession.streemshots.responses);
    return streemshots !== null && streemshots !== void 0 ? streemshots : [];
};
exports.useStreemshotResponses = useStreemshotResponses;
//# sourceMappingURL=room_session.js.map